import { useLocation } from 'react-router'
import { CardSkeleton } from '@/components/layout/card-skeleton'
import { OverviewTabFallback } from '@/routes/load-balancer/tabs/overview/fallback'

export const LoadBalancerPageFallback = () => {
  const location = useLocation()

  if (location.pathname.includes('/overview')) {
    return <OverviewTabFallback />
  }

  return <CardSkeleton />
}
